import { lazyLoad } from 'site-modules/shared/components/lazy-load/lazy-load';
import { FormViewDecorator } from 'site-modules/shared/components/lead-form/unified-lead-form/views/form-view-decorator';

export const MultiDigitalRetailOfferTypeSrpNewAsync = FormViewDecorator(
  lazyLoad({
    loader: () =>
      import(
        /* webpackChunkName: "multi-digital-retail-offer-type-srp-new" */ './multi-digital-retail-offer-type-srp-new'
      ),
    componentName: 'MultiDigitalRetailOfferTypeSrpNew',
  })
);
